import { useBookpalNavigate } from 'component/common/custom/BookpalLink';
import React, { useEffect } from 'react';
import { useMemberInfo } from 'utils/State';



function MainClose(){

    const memberInfo = useMemberInfo();
    const navigate = useBookpalNavigate();

    useEffect(()=>{
        if(memberInfo.is_login){
            navigate("/storage/recent");
        } else {
            navigate("/login");
        }
    });

    return (
        <></>
    );
}

export default MainClose;